import Link from "next/link";
import { Zustandspille } from "./zustandspille";

/**
 * Kennzahl-Karte mit Symbol und Absprung-Link. Herkunft: siehe Herkunftskommentar im Markup.
 */
export function KpiKarte({
  label,
  wert,
  hinweis,
  untertext,
  icon,
  href,
  linkText,
}: {
  label: string;
  wert: number | string;
  /** Graue Zeile unter dem Wert, die den Geltungsbereich sagt (M-004 TP4: „nur dieses Projekt“). Keine Handlungsaussage. */
  untertext?: string;
  /** Zusatz unter dem Wert (z. B. „3 überfällig"): Zustandspille mit Punkt (M-001), nie rote Fließschrift. */
  hinweis?: string;
  icon: React.ReactNode;
  /**
   * Absprung unter der Kennzahl. Fehlt er (additiv, M-100: der Aufrufer bietet den Absprung nur mit dem Recht der Zielseite an, r110),
   * entfällt die Fußzeile; die Kennzahl selbst bleibt.
   */
  href?: string;
  linkText?: string;
}) {
  return (
    <>
    {/* Preline: data-display/data-display-sub-analytics-kpis/data-display-cat-kpi-cards/kpi-card-with-icon-and-link */}
    <div className="flex flex-col bg-card border border-card-line shadow-2xs rounded-xl">
      <div className="p-4 md:p-5 flex justify-between gap-x-3">
        <div>
          <p className="text-xs uppercase text-muted-foreground-1">{label}</p>
          <h3 className="mt-1 text-xl sm:text-2xl font-medium text-foreground">{wert}</h3>
          {untertext && <p className="mt-1 text-xs text-muted-foreground-1">{untertext}</p>}
          {hinweis && (
            <div className="mt-2">
              <Zustandspille ton="ueberfaellig">{hinweis}</Zustandspille>
            </div>
          )}
        </div>
        <div className="shrink-0 flex justify-center items-center size-11 bg-primary text-primary-foreground rounded-full" aria-hidden="true">
          {icon}
        </div>
      </div>

      {href && linkText && (
        <Link
          className="py-3 px-4 md:px-5 inline-flex justify-between items-center text-sm text-muted-foreground-2 border-t border-card-footer hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus rounded-b-xl"
          href={href}
        >
          {linkText}
          <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </Link>
      )}
    </div>
    </>
  );
}
